export const transformProvidersTableItems = (substances: any) =>
    substances?.flatMap(
        (sustancia: any) =>
            sustancia?.proveedores?.length
                ? sustancia.proveedores.map((proveedor: any) => ({
                      ...sustancia, // Keep all sustancia fields
                      proveedor // Attach the current proveedor
                  }))
                : [] // Ensure at least one row if no proveedores
    );
